const data = {
  piuVersioniOptions: [
    { code: "1.1b", description: "Sì" },
    { code: "1.2b", description: "No" },
  ],
  compagniaOptions: [
    { code: "2.1", description: "Aviva Life S.p.A.", extCode: "1.00091" },
    { code: "2.2", description: "Europ Assistance S.p.A.", extCode: "1.00108" },
    { code: "2.3", description: "GenertelLife S.p.A.", extCode: "1.00141" },
    { code: "2.4", description: "Global Assistance - S.p.A.", extCode: "1.00111" },
    { code: "2.5", description: "Zurich Investments Life S.p.A.", extCode: "1.00027" },
    { code: "2.6", description: "MetLife S.p.A.", extCode: "1.00109" },
    { code: "2.7", description: "Allianz Darta Saving Life Assurance dac", extCode: "1.00152" },
    { code: "2.8", description: "Net Insurance S.p.A.", extCode: "1.00136" },
    { code: "2.9", description: "Demo Insurance S.p.A.", extCode: "0.00000" },
  ],
  mercatoOptions: [
    { code: "3.1", description: "Retail" },
    { code: "3.2", description: "Private" },
    { code: "3.3", description: "Business" },
  ],
  canaleOptions: [
    { code: "4.1", description: "Banca" },
    { code: "4.2", description: "Consulenti Finanziari" },
    { code: "4.3", description: "Agenti" },
    { code: "4.4", description: "Broker" },
    { code: "4.5", description: "Diretto" },
  ],
  distributoriOptions: [
    { code: "10537050964", description: "Banco BPM" },
    { code: "00043260140", description: "Credito Valtellinese" },
  ],
  tipologiaProdottoOptions: [
    { code: "6.1", description: "Unit Linked Classica" },
    { code: "6.2", description: "Unit Linked Protetta" },
    { code: "6.3", description: "Unit Linked Ibrida" },
    { code: "6.4", description: "Multiramo" },
    { code: "6.5", description: "Ramo I - Tradizionale" },
    { code: "6.6", description: "Ramo I - Rendita" },
    { code: "6.7", description: "Ramo I - Capitale Differito" },
    { code: "6.8", description: "Ramo V" },
    { code: "6.9", description: "PIR" },
    { code: "6.10", description: "Variable Annuity" },
    { code: "6.11", description: "PIP" },
  ],
  tipologiaSottostantiOptions: [
    { code: "7.1", description: "Gestione Separata" },
    { code: "7.2", description: "Fondi Interni" },
    { code: "7.3", description: "OICR" },
    { code: "7.4", description: "ETF" },
  ],
  prodCommercioOptions: [
    { code: "8.1", description: "Sì" },
    { code: "8.2", description: "No" },
  ],
  tipologiaPremioOptions: [
    { code: "11.1", description: "PIC" },
    { code: "11.2", description: "PAC" },
    { code: "11.3", description: "PIC + PAC" },
    { code: "11.4", description: "PIC o PAC" },
    { code: "11.5", description: "PIC + eventuale PAC" },
    { code: "11.6", description: "PAC + eventuale PIC" },
  ],
  rendMinGarantitoOptions: [
    { code: "30.1", description: "Riconosciuto annualmente" },
    { code: "30.2", description: "Riconosciuto ad evento" },
    { code: "30.3", description: "Non riconosciuto" },
  ],
  presenzaConsolidamentoAnnuoRivalutazioniContrattualiOptions: [
    { code: "32.1", description: "Sì" },
    { code: "32.2", description: "No" },
  ],
  fondoUtiliOptions: [
    { code: "34.1", description: "Presente" },
    { code: "34.2", description: "Non presente" },
  ],
  tipologiaFondiInterniOptions: [
    { code: "37.1", description: "Fondi Interni Azionari" },
    { code: "37.2", description: "Fondi Interni Obbligazionari" },
    { code: "37.3", description: "Fondi Interni Bilanciati" },
    { code: "37.4", description: "Fondi Interni Flessibili" },
    { code: "37.5", description: "Fondi Interni Monetari" },
  ],
  numOICRETFOptions: [
    { code: "38.1", description: "1-50" },
    { code: "38.2", description: "51-100" },
    { code: "38.3", description: "101-250" },
    { code: "38.4", description: "251-500" },
    { code: "38.5", description: "501-1000" },
    { code: "38.6", description: ">1000" },
  ],
  presenzaProtezioneCapitaleOptions: [
    { code: "39.1", description: "Sì" },
    { code: "39.2", description: "No" },
  ],
  opzioniContrattualiTipologiaOptions: [
    { code: "45.1", description: "Cedola" },
    { code: "45.2", description: "Decumulo" },
    { code: "45.3", description: "Rendita" },
    { code: "45.4", description: "Stop Loss" },
    { code: "45.5", description: "Take Profit" },
    { code: "45.6", description: "Progressive Investment" },
    { code: "45.7", description: "Automatic Rebalance" },
    { code: "45.8", description: "Downtrend Opportunity" },
    { code: "45.9", description: "Life Cycle" },
    { code: "45.10", description: "Altre opzioni contrattuali" },
    { code: "45.11", description: "Non presenti" },
  ],
  garanzieAssicurativeTipologiaOptions: [
    { code: "62.1", description: "Maggiorazione caso morte standard" },
    { code: "62.2", description: "Maggiorazione caso morte per infortunio" },
    { code: "62.3", description: "Maggiorazione caso morte per incidente stradale" },
    { code: "62.4", description: "Maggiorazione caso morte per minusvalenza" },
    { code: "62.5", description: "TCM stand alone" },
    { code: "62.6", description: "Long Term Care" },
    { code: "62.7", description: "Dread Disease" },
    { code: "62.8", description: "Invalidità/Inabilità" },
    { code: "62.9", description: "Altre garanzie assicurative" },
    { code: "62.10", description: "Non presenti" },
  ],
  maggiorazioneCasoMorteStandardOptions: [
    { code: "63.1", description: "Ramo I" },
    { code: "63.2", description: "Ramo III" },
    { code: "63.3", description: "Ramo I + Ramo III" },
  ],
  maggiorazioneCasoMortePerInfortunioOptions: [
    { code: "65.1", description: "Facoltativa" },
    { code: "65.2", description: "Obbligatoria" },
  ],
  maggiorazioneCasoMortePerIncidenteStradaleOptions: [
    { code: "67.1", description: "Facoltativa" },
    { code: "67.2", description: "Obbligatoria" },
  ],
  maggiorazioneCasoMortePerMinusvalenzaOptions: [
    { code: "69.1", description: "Facoltativa" },
    { code: "69.2", description: "Obbligatoria" },
  ],
  TCMStandAloneOptions: [
    { code: "71.1", description: "Facoltativa" },
    { code: "71.2", description: "Obbligatoria" },
  ],
  longTermCareOptions: [
    { code: "73.1", description: "Facoltativa" },
    { code: "73.2", description: "Obbligatoria" },
  ],
  dreadDiseaseOptions: [
    { code: "75.1", description: "Facoltativa" },
    { code: "75.2", description: "Obbligatoria" },
  ],
  invaliditaInabilitaOptions: [
    { code: "77.1", description: "Facoltativa" },
    { code: "77.2", description: "Obbligatoria" },
  ],
  tipologiaBonusIngressoOptions: [
    { code: "81.1", description: "Percentuale fissa" },
    { code: "81.2", description: "Fasce cumulo premi versati" },
    { code: "81.3", description: "Fasce scaglioni cumulo premi versati (criterio Irpef)" },
    { code: "81.4", description: "Fasce premi versati annui" },
    { code: "81.5", description: "Fasce patrimonio potenziale" },
    { code: "81.6", description: "Altro" },
    { code: "81.7", description: "Non riconosciuto" },
  ],
  tipologiaBonusFedeltaOptions: [
    { code: "83.1", description: "Percentuale del capitale" },
    { code: "83.2", description: "Percentuale dei premi versati" },
    { code: "83.3", description: "Percentuale del premio ricorrente" },
    { code: "83.4", description: "Altro" },
    { code: "83.5", description: "Non riconosciuto" },
  ],
  tipologiaCaricamentoPICOptions: [
    { code: "86.1", description: "Percentuale fissa" },
    { code: "86.2", description: "Fasce cumulo premi versati" },
    { code: "86.3", description: "Fasce scaglioni cumulo premi versati (criterio Irpef)" },
    { code: "86.4", description: "Fasce premi versati annui" },
    { code: "86.5", description: "Percentuale funzione del tempo" },
    { code: "86.6", description: "Fasce cumulo premi versati funzione del tempo" },
    { code: "86.7", description: "Fasce scaglioni cumulo premi versati (criterio Irpef) funzione del tempo" },
    { code: "86.8", description: "Fasce premi versati annui funzione del tempo" },
    { code: "86.9", description: "Fasce patrimonio potenziale" },
    { code: "86.10", description: "Fasce patrimonio potenziale e fasce cumulo premi versati" },
    { code: "86.11", description: "Fasce cumulo premi versati e fasce versamenti futuri previsti" },
    { code: "86.12", description: "Percentuale funzione della durata contrattuale" },
    { code: "86.13", description: "Percentuale funzione della durata piano pagamento premi" },
    { code: "86.14", description: "Fasce importo totale piano pagamento premi" },
    { code: "86.15", description: "Altro" },
    { code: "86.16", description: "Non applicato" },
  ],
  tipologiaCaricamentoPACOptions: [
    { code: "88.1", description: "Percentuale fissa" },
    { code: "88.2", description: "Fasce cumulo premi versati" },
    { code: "88.3", description: "Fasce scaglioni cumulo premi versati (criterio Irpef)" },
    { code: "88.4", description: "Fasce premi versati annui" },
    { code: "88.5", description: "Percentuale funzione del tempo" },
    { code: "88.6", description: "Fasce cumulo premi versati funzione del tempo" },
    { code: "88.7", description: "Fasce scaglioni cumulo premi versati (criterio Irpef) funzione del tempo" },
    { code: "88.8", description: "Fasce premi versati annui funzione del tempo" },
    { code: "88.9", description: "Fasce patrimonio potenziale" },
    { code: "88.10", description: "Fasce patrimonio potenziale e fasce cumulo premi versati" },
    { code: "88.11", description: "Fasce cumulo premi versati e fasce versamenti futuri previsti" },
    { code: "88.12", description: "Percentuale funzione della durata contrattuale" },
    { code: "88.13", description: "Percentuale funzione della durata piano pagamento premi" },
    { code: "88.14", description: "Fasce importo totale piano pagamento premi" },
    { code: "88.15", description: "Altro" },
    { code: "88.16", description: "Non applicato" },
  ],
  tipologiaCommissioneGestioneSeparataOptions: [
    { code: "91.1", description: "Percentuale fissa" },
    { code: "91.2", description: "Fasce cumulo capitale" },
    { code: "91.3", description: "Fasce scaglioni cumulo capitale (criterio Irpef)" },
    { code: "91.4", description: "Fasce premi versati annui" },
    { code: "91.5", description: "Percentuale funzione del tempo" },
    { code: "91.6", description: "Fasce cumulo capitale funzione del tempo" },
    { code: "91.7", description: "Fasce scaglioni cumulo capitale (criterio Irpef) funzione del tempo" },
    { code: "91.8", description: "Fasce premi versati annui funzione del tempo" },
    { code: "91.9", description: "Percentuale del rendimento gestione separata" },
    { code: "91.10", description: "Percentuale funzione del rendimento gestione separata" },
    { code: "91.11", description: "Altro" },
  ],
  tipologiaCommissioneFondiInterniOptions: [
    { code: "93.1", description: "Percentuale fissa" },
    { code: "93.2", description: "Fasce cumulo capitale" },
    { code: "93.3", description: "Fasce scaglioni cumulo capitale (criterio Irpef)" },
    { code: "93.4", description: "Fasce premi versati annui" },
    { code: "93.5", description: "Percentuale funzione del tempo" },
    { code: "93.6", description: "Fasce cumulo capitale funzione del tempo" },
    { code: "93.7", description: "Fasce scaglioni cumulo capitale (criterio Irpef) funzione del tempo" },
    { code: "93.8", description: "Fasce premi versati annui funzione del tempo" },
    { code: "93.9", description: "Altro" },
  ],
  tipologiaSpeseGestionePolizzaOICRETFOptions: [
    { code: "100.1", description: "Percentuale fissa" },
    { code: "100.2", description: "Fasce cumulo capitale" },
    { code: "100.3", description: "Fasce scaglioni cumulo capitale (criterio Irpef)" },
    { code: "100.4", description: "Fasce premi versati annui" },
    { code: "100.5", description: "Percentuale funzione del tempo" },
    { code: "100.6", description: "Fasce cumulo capitale funzione del tempo" },
    { code: "100.7", description: "Fasce scaglioni cumulo capitale (criterio Irpef) funzione del tempo" },
    { code: "100.8", description: "Fasce premi versati annui funzione del tempo" },
    { code: "100.9", description: "Altro" },
  ],
  applicazioneCommissioniOverperformanceOptions: [
    { code: "107.1", description: "Sì" },
    { code: "107.2", description: "No" },
  ],
  applicazioneCommissioniUscitaOptions: [
    { code: "110.1", description: "Standard" },
    { code: "110.2", description: "Non standard" },
    { code: "110.3", description: "Non applicate" },
  ],
  yesNoOptions: [
    { code: "true", description: "Sì" },
    { code: "false", description: "No" },
  ],
  facoltativaObbligatoriaOptions: [
    { code: "f", description: "Facoltativa" },
    { code: "o", description: "Obbligatoria" },
  ],
};

const selectChoices = {
  piuVersioni: { code: "", description: "" },
  compagnia: { code: "", description: "", extCode: "" },
  mercato: [], // multiselect
  canale: [], // multiselect
  distributori: [], // multiselect
  tipologiaProdotto: { code: "", description: "" },
  tipologiaSottostanti: [], // multiselect
  prodCommercio: { code: "", description: "" },
  tipologiaPremio: { code: "", description: "" },
  rendMinGarantito: { code: "", description: "" },
  presenzaConsolidamentoAnnuoRivalutazioniContrattuali: { code: "", description: "" },
  fondoUtili: { code: "", description: "" },
  tipologiaFondiInterni: [],
  numOICRETF: { code: "", description: "" },
  presenzaProtezioneCapitale: { code: "", description: "" },
  opzioniContrattualiTipologia: [],
  garanzieAssicurativeTipologia: [],
  maggiorazioneCasoMorteStandard: { code: "", description: "" },
  maggiorazioneCasoMortePerInfortunio: { code: "", description: "" },
  maggiorazioneCasoMortePerIncidenteStradale: { code: "", description: "" },
  maggiorazioneCasoMortePerMinusvalenza: { code: "", description: "" },
  TCMStandAlone: { code: "", description: "" },
  longTermCare: { code: "", description: "" },
  dreadDisease: { code: "", description: "" },
  invaliditaInabilita: { code: "", description: "" },
  tipologiaBonusIngresso: { code: "", description: "" },
  tipologiaBonusFedelta: { code: "", description: "" },
  tipologiaCaricamentoPIC: { code: "", description: "" },
  tipologiaCaricamentoPAC: { code: "", description: "" },
  tipologiaCommissioneGestioneSeparata: { code: "", description: "" },
  tipologiaCommissioneFondiInterni: { code: "", description: "" },
  tipologiaSpeseGestionePolizzaOICRETF: { code: "", description: "" },
  applicazioneCommissioniOverperformance: { code: "", description: "" },
  applicazioneCommissioniUscita: { code: "", description: "" },
};

export { selectChoices };
export default data;
